import React, {useEffect, useState} from "react";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import radioBtn1 from "../../../static/image/v2/popup/radioBtn1.png";
import radioBtn2 from "../../../static/image/v2/popup/radioBtn2.png";
import imgBtn from "../../../static/image/v2/popup/imgBtn.png";
import imgRemoveBtn from "../../../static/image/v2/imgRemoveBtn.png";
import optionBtn1 from "../../../static/image/v2/menu/optionBtn1.png";
import {closePopup, getChecked, getValue, setChecked, setValue} from "../../../static/js/Common2";
import {bestMenuListChange, menuListChange, newMenu, setMenu} from "../../../static/js/service/menuService";
import $ from "jquery";
import * as MenuInfo from "../../../static/js/MenuInfo";
import {MenuInfoText} from "../../../static/js/MenuInfo";
import MenuDrag from "../../menu/MenuDrag";
import {openPopup} from "../../../utils/CommonUtils";
import BestMenuDrag from "../../menu/BestMenuDrag";
import MenuImageSearchPopup2 from "../../popup/MenuImageSearchPopup2";

export default function MenuListPopupV2(props) {
  let shopId =props.shopId;
  let list = props.list;
  let menuInfoList = MenuInfoText;
  let category = props.category;
  let optionList = props.optionList;
  let serviceType = props.serviceType;
  const reset = props.reset;
  const setReset = props.setReset;
  const bestMenuList = props.bestMenuList;
  let [fileList, setFileList] = useState([]);
  let [modifyFileList, setModifyFileList] = useState([]);
  let [menuList, setMenuList] = useState([]);
  let [newBestMenuList, setNewBestMenuList] = useState([]);

  useEffect(() => {
    setNewBestMenuList(bestMenuList);
  }, [bestMenuList]);

  let menuGrpList1 = list.map(({id , name}) => {
    return (
      <li className="selectoption" key={id} data-name={name} onClick={() => menuGrpListEvent(id, name, "menuGrpSelect")}>{name}</li>
    )
  })
  let menuGrpList2 = list.map(({id , name}) => {
    return (
      <li className="selectoption" key={id} data-name={name} onClick={() => menuGrpListEvent(id, name, "menuGrpSelect2")}>{name}</li>
    )
  })
  let menuDrgSelect = list.map(({id , name}) => {
    return (
      <li className="selectoption" key={id} data-name={name} onClick={() => menuGrpListEvent(id, name, "menuDrgSelect")}>{name}</li>
    )
  })
  let menuInfoList1 = menuInfoList.map(({idx , name}) => {
    return (
        <li className="selectoption" key={idx} data-name={name} onClick={() => menuGrpListEvent(idx, name, "menuInfoSelect1")}>{name}</li>
    )
  })
  let menuInfoList2 = menuInfoList.map(({idx , name}) => {
    return (
      <li className="selectoption" key={idx} data-name={name} onClick={() => menuGrpListEvent(idx, name, "menuInfoSelect2")}>{name}</li>
    )
  })

  let categoryList1 = category.map(({id , name}) => {
    return (
      <li className="selectoption" key={id} onClick={() => menuGrpListEvent(id, name, "categorySelect")}>{name}</li>
    )
  })
  let categoryList2 = category.map(({id , name}) => {
    return (
      <li className="selectoption" key={id} onClick={() => menuGrpListEvent(id, name, "categorySelect2")}>{name}</li>
    )
  })
  let optionGrpList = optionList.map(({id, name}) => {
    return (
      <li className="selectoption" key={id} data-name={name} onClick={() => menuGrpListEvent(id, name, "menuOptionSelect1")}>{name}</li>
    )
  })
  let optionGrpList2 = optionList.map(({id, name}) => {
    return (
      <li className="selectoption" key={id} data-name={name} onClick={() => menuGrpListEvent(id, name, "menuOptionSelect2")}>{name}</li>
    )
  })
    let optionGrpSelectList = optionList.map(({id, name}) => {
      return (
        <li key={id}>
          <input id={`selectNewOption${id}`} data-name={name} type="checkbox" />
          <label htmlFor={`selectNewOption${id}`}>{name}</label>
        </li>
      )
    })

  const handleBestMenuListEvent = (type) => {
    if (type === 1) {
      const getMenuName = getValue("menuName");
      let newList = bestMenuList;

      if (!newBestMenuList.find((value) => value.id === 0)) {
        newList.push({
          id: 0,
          name: getMenuName,
          mainMenuVisibleIndex: bestMenuList.length + 1
        });
      } else {
        newBestMenuList.find((value) => value.id === 0).name = getMenuName;
      }
      setNewBestMenuList(newList);
      setReset(reset + 1);
    }

    openPopup("menuPopup5");
  };

  const menuGrpListEvent = async (id, name, type) => {
    let selectBox = document.querySelector(`#${type} .selectText`);
    selectBox.setAttribute("data-id", id);
    selectBox.innerText = name;

    if(type === "menuInfoSelect1") {
      menuInfo1(id)
    } else if(type === "menuInfoSelect2") {
      menuInfo2(id)
    } else if(type === "menuDrgSelect") {
      for(let i = 0; list.length > i; i++) {
        if(id === list[i].id) {
          setMenuList(list[i].menuList);
        }
      }
    }
  }

  const optionGrpAddEvent = (type) => {
    let selectText = document.querySelector(`#menuOptionSelect${type} .selectText`);
    let optionList = [];
    let optionBox = document.querySelectorAll(`.menuPopup${type} .optionNameBox`);
    let optionListBox = document.querySelector(`.menuOptionList${type}`);

    let dataId = selectText.getAttribute("data-id");
    let name = selectText.innerText;
    optionBox.forEach((element) => {
      if(type === 1) {
        optionList.push(element.getAttribute("data-id"));
      } else if(type === 2) {
        if(!element.classList.contains("hide")) {
          optionList.push(element.getAttribute("data-id"));
        }
      }
    })

    if(Number(dataId) === 0) {
      alert("옵션 그룹을 선택해주세요.");
      return false;
    }

    let result = true;

    for(let i = 0; optionList.length > i; i++) {
      if(Number(optionList[i]) === Number(dataId)) {
        result = false
      }
    }

    if(result) {
      const div = document.createElement("div");
      div.innerHTML = `<input type='text' class='optionName' value='${ name }' name='optionName' readOnly />` +
                      `<button type='button' class='menuPriceRemoveBtn'>삭제</button>`;

      div.setAttribute('class', 'optionNameBox addOptionNameBox');
      div.setAttribute('data-id', dataId);
      optionListBox.appendChild(div);

      let removeBtn = div.querySelector(".menuPriceRemoveBtn");

      removeBtn.addEventListener("click", () => {
        div.remove();
      });
    } else {
      alert("동일한 옵션은 선택할 수 없습니다.");
      return false;
    }
  }

  const menuPriceEvent = (type) => {
    let addBox = document.querySelectorAll(`.addMenuPrice${type}`);
    let addBoxList = [];
    let priceList = document.getElementById(`menuPriceList${type}`);

    addBox.forEach((element) => {
      if(!element.classList.contains("hide")) {
        addBoxList.push(element);
      }
    })

    if(addBoxList.length > 8) {
      alert("최대 10개까지 가능합니다.");
    } else {
      let div = document.createElement("div");
      div.innerHTML = `<input type='text' class='menuPriceName' name='menuPriceName' placeholder='가격명' />` +
                      `<input type='number' class='menuPrice number' name='menuPrice' placeholder='가격 입력(숫자만)' />` +
                      `<input type='number' class="menuSalePrice number width134 ${serviceType === 6 ? "" : "hide"}" name='menuSalePrice' placeholder='할인 가격(숫자만)' />` +
                      `<button type='button' class='menuPriceRemoveBtn'>삭제</button>`

      div.setAttribute('class', `menuPriceBox addMenuPrice addMenuPrice${type}`)

      priceList.appendChild(div);

      div.lastChild.addEventListener('click', () => {
        div.remove();
      });

      div.querySelectorAll(".number").forEach((element) => {
        element.addEventListener("change", (e) => {
          let n = e.target.value;

          if(n < 0) {
            alert('0원 이상 입력가능합니다.');
            e.target.value = 0;
          } else if(n === '') {
            e.target.value = '';
          }
        });
      });
    }
  }

  const menuStatesBtnEvent = (id, type) => {
    let menuStatesBox = document.querySelectorAll(`.menuStatesBtn${type}`);
    menuStatesBox.forEach((element) => {
      element.classList.remove("active");
    })
    document.querySelector(`.menuStatesBtn${type}${id}`).classList.add("active");
  }

  const fileUpload = (e, type) => {
    const file = e.target;
    const dataId = file.getAttribute("data-id");
    document.querySelector(".lodding").classList.remove("hide");

    // 이미지 정보 인코딩
    let fileReader = new FileReader();
    fileReader.onload = (base64) => {
      const image = new Image();
      const size = file.files[0].size;
      image.src = base64.target.result;

      image.onload = () => {
        const arr1 = file.files[0].name.split(".");
        const arr2 = base64.target.result.split(",");
        let fileImg;

        if(size <= 3072000) {
          document.querySelector(`#${type} .menuImg`).setAttribute("src", base64.target.result);
          document.querySelector(`#${type} .menuImg`).setAttribute("data-id", "0");
          document.querySelector(`#${type} .imgBtn`).classList.add("hide");
          document.querySelector(`#${type} .imageSearchBtn`).classList.add("hide");
          document.querySelector(`#${type} .menuImgPreview`).classList.remove("hide");

          if(Number(dataId) !== 0) {
            fileImg = {
              menuImageId: Number(dataId),
              encodedFile: arr2[1],
              fileName: arr1[0] + '_9',
              fileExtension: arr1[1],
              imageType: 9
            }

            setModifyFileList([...modifyFileList, fileImg]);
          } else {
            fileImg = {
              encodedFile: arr2[1],
              fileName: arr1[0] + '_9',
              fileExtension: arr1[1],
              imageType: 9
            }

            setFileList([...fileList, fileImg]);
          }
        } else {
          setFileList([]);
          setModifyFileList([]);
        }
        document.querySelector(".lodding").classList.add("hide");
      }
    }
    fileReader.readAsDataURL(file.files[0]);
  }

  const handleChange1 = (e) => {  // <- input값으로 text 변경 함수
        const fileArr = e.target.files;
        let file
        var preview = document.querySelectorAll('.detailPreview')
        var number = 1

        if(preview.length !== 0) {
            number = Number(preview[preview.length - 1].getAttribute('data-number'))
        }

        if(preview.length >= 10) {
            alert('최대 10개까지 등록할 수 있습니다.')
            $("#detailFile1").val("")
        } else {
            $(".lodding").removeClass("hide")
            for(var i = 0; fileArr.length > i; i++) {
                file = fileArr[i]
                var fileReader = new FileReader()
                fileReader.onload = (base64) => {
                    const image = new Image()
                    image.src = base64.target.result

                    image.onload = (e) => {
                        const $canvas = document.createElement('canvas')
                        const ctx = $canvas.getContext('2d')

                        var max_size = 1280
                        var width = e.target.width
                        var height = e.target.height

                        if (width > max_size) {
                            height *= max_size / width;
                            width = max_size;
                        }

                        $canvas.width = width
                        $canvas.height = height

                        ctx.drawImage(e.target, 0 ,0, width, height)

                        let fileInfo = $canvas.toDataURL(`image/jpeg`, 1)

                        var arr1 = file.name.split('.');
                        var arr2 = fileInfo.split(',');

                        var li = document.createElement('li')
                        li.innerHTML = `<img src=${ base64.target.result } />` +
                            `<button class='removeBtn'><img src=${ imgRemoveBtn } alt='' data-number=${ number + i } /></button>`
                        li.setAttribute('class', 'detailPreview')
                        li.setAttribute('data-file', arr2[1])
                        li.setAttribute('data-name', arr1[0] + "_10")
                        li.setAttribute('data-extension', arr1[1])
                        li.setAttribute('data-number', number + i)
                        li.setAttribute('data-modi', 0)

                        var img = document.createElement('img')
                        img.setAttribute('src', base64.target.result)
                        img.setAttribute('class', `shopImg${ number + i }`)

                        $('.detailImgBox1').append(li)
                        $('.shopDetailImgBox1').append(img)

                        li.querySelector('.removeBtn').addEventListener('click', (e) => {
                            let dataset = e.target.dataset
                            let number = dataset.number
                            document.querySelector(`.shopImg${ number }`).remove()
                            li.remove()
                        })

                        $("#detailFile1").val("")
                        $(".lodding").addClass("hide")
                    }
                }

                fileReader.readAsDataURL(file);
            }

        }

    };
  const handleChange2 = (e) => {  // <- input값으로 text 변경 함수
    const fileArr = e.target.files;
    let file
    var preview = document.querySelectorAll('#modifyMenuPopup .detailPreview')
    let previewList = [];
    preview.forEach((element) => {
      if(!element.classList.contains("hide")) {
        previewList.push(preview);
      }
    })


    var number = 1

    if(preview.length !== 0) {
      number = Number(preview[preview.length - 1].getAttribute('data-number'))
    }

    if(previewList.length === 10) {
      $("#detailFile2").val("")
      alert('최대 10개까지 등록할 수 있습니다.')
    } else {
      $(".lodding").removeClass("hide")
      for(var i = 0; fileArr.length > i; i++) {
        file = fileArr[i]
        var fileReader = new FileReader()
        fileReader.onload = (base64) => {
          const image = new Image()
          image.src = base64.target.result

          image.onload = (e) => {
            const $canvas = document.createElement('canvas')
            const ctx = $canvas.getContext('2d')

            var max_size = 1280
            var width = e.target.width
            var height = e.target.height

            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }

            $canvas.width = width
            $canvas.height = height

            ctx.drawImage(e.target, 0 ,0, width, height)

            let fileInfo = $canvas.toDataURL(`image/png`, 1)

            var arr1 = file.name.split('.');
            var arr2 = fileInfo.split(',');

            var li = document.createElement('li')
            li.innerHTML = `<img src=${ base64.target.result } />` +
                `<button class='removeBtn'><img src=${ imgRemoveBtn } alt='' data-number=${ number + i } /></button>`
            li.setAttribute('class', 'detailPreview')
            li.setAttribute('data-file', arr2[1])
            li.setAttribute('data-name', arr1[0] + "_10")
            li.setAttribute('data-extension', arr1[1])
            li.setAttribute('data-number', number + i)
            li.setAttribute('data-modi', 0)

            var img = document.createElement('img')
            img.setAttribute('src', base64.target.result)
            img.setAttribute('class', `shopImg${ number + i }`)

            $('.detailImgBox2').append(li)
            $('.shopDetailImgBox2').append(img)

            li.querySelector('.removeBtn').addEventListener('click', (e) => {
              let dataset = e.target.dataset
              let number = dataset.number
              document.querySelector(`.shopImg${ number }`).remove()
              li.remove()
            })

            $("#detailFile2").val("")
            $(".lodding").addClass("hide")
          }
        }

        fileReader.readAsDataURL(file);
      }
    }
  };
  const imageRemove = (type) => {
    document.querySelector(`#${type} .menuImg`).setAttribute("src", "");
    document.querySelector(`#${type} .menuImg`).setAttribute("data-id", "0");
    document.querySelector(`#${type} .menuImgPreview`).classList.add("hide");
    document.querySelector(`#${type} .imgBtn`).classList.remove("hide");
    document.querySelector(`#${type} .imageSearchBtn`).classList.remove("hide");
    document.querySelector(`#${type} .menuImgFile`).value = "";
    //document.getElementById("menuImgFile2").value = "";
    setFileList([]);
  }

  const addMenuEvent = async () => {
    const menuGrpId = document.querySelector("#menuGrpSelect .selectText").getAttribute("data-id");
    let categoryId = document.querySelector("#categorySelect .selectText").getAttribute("data-id");
    const menuName = getValue("menuName");
    const bestMenu = document.getElementById("bestMenu").checked;
    const adultMenu = document.getElementById("adultMenu").checked;

    const menuPriceBox = document.querySelectorAll("#menuPriceList1 .menuPriceBox");
    let menuPriceList = [];
    menuPriceBox.forEach((element) => {
      const menuPriceName = element.querySelector(".menuPriceName").value;
      const menuPrice = element.querySelector(".menuPrice").value;
      let menuSalePrice = element.querySelector(".menuSalePrice").value;

      if(!menuSalePrice) {
        menuSalePrice = menuPrice;
      }

      if(menuPrice) {
        menuPriceList.push({
          name: menuPriceName,
          cost: Number(menuPrice),
          saleCost: Number(menuSalePrice)
        });
      }
    });

    const menuCount = getValue("menuCount");
    const status = document.querySelector('input[name="menuStates1"]:checked').value;
    const menuDesc = getValue("menuDesc");
    const menuInfo = getValue("menuInfo");
    const optionListBox = document.querySelectorAll(".menuOptionList1 .optionNameBox");
    let optionList = [];
    optionListBox.forEach((element) => {
      optionList.push(Number(element.getAttribute("data-id")));
    })

    optionList.sort();

    let states = true;
    if(status === '2') {
      states = false
    }

    if(menuGrpId === "0") {
      alert("메뉴 그룹을 선택해주세요.");
      return false;
    }
    if(categoryId === "0") {
      alert("카테고리를 선택해주세요.");
      return false;
    }
    if(!menuName) {
      alert("메뉴명을 입력해주세요.");
      return false;
    }
    if(menuPriceList.length === 0) {
      alert("메뉴 가격을 최소 1개 이상 입력해주세요.");
      return false;
    }

    let visible = 1;
    for(let i = 0; list.length > i; i++) {
      if(Number(menuGrpId) === list[i].id) {
        if(list[i].menuList.length > 0) {
          let number = list[i].menuList[list[i].menuList.length - 1];
          visible = Number(number.visibleIndex) + 1;
        }
      }
    }

    let data = {
      categoryId: Number(categoryId),
      status: Number(status),
      name: menuName,
      cost: menuPriceList[0].cost,
      saleCost: menuPriceList[0].cost,
      count: Number(menuCount),
      visibleIndex: visible,
      isVisible: states,
      isMainMenu: bestMenu,
      isAdultMenu: adultMenu,
      isSafeFood: false,
      menuInfoList: []
    }

    let setBestMenuList = []

    if (bestMenu) {
      const bestMenuListBox = document.querySelectorAll("#menuPopup5 .popupDrag p")

      bestMenuListBox.forEach((value, index) => {
        const dataId = Number(value.getAttribute("data-id"));
        const number = index + 1

        if (dataId === 0) {
          data.mainMenuVisibleIndex = number
        } else {
          setBestMenuList.push({
            menuId: dataId,
            mainMenuVisibleIndex: number
          })
        }
      })
    }

    if (fileList.length > 0) data.menuImageFileList = fileList;

    if(serviceType === 6) {
      let detailImageBox = document.querySelectorAll(".detailPreview")
      detailImageBox.forEach((element) => {
        let dataFile = element.getAttribute("data-file");
        let dataName = element.getAttribute("data-name");
        let dataExtension = element.getAttribute("data-extension");

        fileList.push({
          imageType: 10,
          fileName: dataName,
          fileExtension: dataExtension,
          encodedFile: dataFile
        })
      })

      let menuInfoList = [];
      let menuInfoBox = document.querySelectorAll(".menuInfoList1 .menuInfoInputBox");
      menuInfoBox.forEach((element) => {
        let menuInfoTitle = element.querySelector(".menuInfoTitle").innerText;
        let menuInfoValue = element.querySelector(".menuInfoInput").value;

        if(menuInfoValue === '') {
          menuInfoValue = '-'
        }

        menuInfoList.push({
          title: menuInfoTitle,
          desc: menuInfoValue
        });
      });

      if(menuInfoList.length > 0) {
        data.menuInfoList = menuInfoList;
      }
    } else {
      data.struct = menuInfo;
      data.desc = menuDesc;
    }

    document.getElementById("menu1Btn").setAttribute("disabled", true);

    if (setBestMenuList.length > 0) {
      await bestMenuListChange(shopId, setBestMenuList);
    }

    await newMenu(shopId, menuGrpId, data, menuPriceList, optionList);
  }

  const setMenuEvent = async () => {
    const menuGrpId = Number(document.querySelector("#menuGrpSelect2 .selectText").getAttribute("data-id"));
    const categoryId = document.querySelector("#categorySelect2 .selectText").getAttribute("data-id");
    const menuId = getValue("menuId2");
    const menuName = getValue("menuName2");
    const bestMenu = getChecked("bestMenu2");
    const adultMenu = getChecked("adultMenu2");
    const count = getValue("modiMenuCount");
    const status = document.querySelector('input[name="menuStates2"]:checked').value;
    const menuDesc = getValue("menuDesc2");
    const menuInfo = getValue("menuInfo2");

    let states = true;
    if(status === '2') {
      states = false
    }

    if(String(menuGrpId) === "0") {
      alert("메뉴 그룹을 선택해주세요.");
      return false;
    }
    if(String(categoryId) === "0") {
      alert("카테고리를 선택해주세요.");
      return false;
    }
    if(!menuName) {
      alert("메뉴명을 입력해주세요.");
      return false;
    }


    let menuImgPreview = document.querySelector("#menuImgPreview2 .menuImgPreview")
    let menuImgFile = document.getElementById("menuImgFile2");
    let removeImageList = [];

    if(menuImgPreview.classList.contains("hide")) {
      removeImageList.push(Number(menuImgFile.getAttribute("data-id")));
    }

    let priceList = [];
    let setPriceList = [];
    let removePriceList = [];

    let priceBox = document.querySelectorAll("#menuPriceList2 .menuPriceBox");
    priceBox.forEach((element) => {
      let priceNumber = element.getAttribute("data-number");
      let priceId = element.getAttribute("data-id");
      let priceName = element.querySelector(".menuPriceName").value;
      let price = element.querySelector(".menuPrice").value;
      let salePrice = element.querySelector(".menuSalePrice").value;

      if(serviceType !== 6) {
        salePrice = price;
      }

      if(price) {
        if(Number(priceId) === 0) {
          priceList.push({
            name: priceName,
            cost: Number(price),
            saleCost: Number(salePrice)
          })
        } else {
          if(element.classList.contains("hide")) {
            removePriceList.push({
              id: Number(priceId),
              number: Number(priceNumber)
            });
          } else {
            setPriceList.push({
              menuCostId: Number(priceId),
              name: priceName,
              cost: Number(price),
              saleCost: Number(salePrice),
              number: Number(priceNumber)
            });
          }
        }
      }
    });

    if(priceList.length === 0 && setPriceList.length === 0) {
      alert("메뉴 가격을 최소 1개 이상 입력해주세요.");
      return false;
    }

    let optionList = [];
    let removeOptionList = [];
    let optionBox = document.querySelectorAll("#menuOptionList2 .optionNameBox");
    optionBox.forEach((element) => {
      let optionId = element.getAttribute("data-id");

      if(element.classList.contains("modiOptionNameBox") && element.classList.contains("hide")) {
        removeOptionList.push(Number(optionId));
      } else if(!element.classList.contains("modiOptionNameBox")) {
        optionList.push(Number(optionId));
      }
    })

    let data = {
      menuId: Number(menuId),
      status: Number(status),
      name: menuName,
      isVisible: states,
      isMainMenu: bestMenu,
      isAdultMenu: adultMenu
    }

    let adminData = {
      productGrpId: Number(menuGrpId),
      categoryId: Number(categoryId),
      stockCnt: Number(count),
      remCnt: Number(count)
    }

    if(serviceType === 6) {
      let detailImageBox = document.querySelectorAll("#modifyMenuPopup .detailPreview")
      detailImageBox.forEach((element) => {
        if(element.getAttribute("data-modi") === "1") {
          if(element.classList.contains("hide")) {
            removeImageList.push(Number(element.getAttribute("data-id")))
          }
        } else {
          let dataFile = element.getAttribute("data-file");
          let dataName = element.getAttribute("data-name");
          let dataExtension = element.getAttribute("data-extension");

          fileList.push({
            imageType: 10,
            fileName: dataName,
            fileExtension: dataExtension,
            encodedFile: dataFile
          })
        }
      })

      let menuInfoList = [];
      let menuInfoBox = document.querySelectorAll(".menuInfoList2 .menuInfoInputBox");
      menuInfoBox.forEach((element) => {
        let menuInfoTitle = element.querySelector(".menuInfoTitle").innerText;
        let menuInfoValue = element.querySelector(".menuInfoInput").value;

        if(menuInfoValue === '') {
          menuInfoValue = '-'
        }

        menuInfoList.push({
          title: menuInfoTitle,
          desc: menuInfoValue
        });
      });

      if(menuInfoList.length > 0) {
        data.menuInfoList = menuInfoList;
      } else {
        data.menuInfoList = [];
      }
    } else {
      data.struct = menuInfo;
      data.desc = menuDesc;
    }

    if(fileList.length > 0) {
      data.addMenuImageFileList = fileList;
    }
    if(modifyFileList.length > 0) {
      data.setMenuImageFileList = modifyFileList;
    }
    if(removeImageList.length > 0) {
      data.removeMenuImageIdList = removeImageList;
    }

    document.getElementById("menu2Btn").setAttribute("disabled", true);
    sessionStorage.setItem("targetId", `menuBox${menuId}`);

    let setBestMenuList = []

    if (bestMenu) {
      const bestMenuListBox = document.querySelectorAll("#menuPopup5 .popupDrag p")

      bestMenuListBox.forEach((value, index) => {
        const dataId = Number(value.getAttribute("data-id"));
        const number = index + 1

        if (dataId === menuId) {
          data.mainMenuVisibleIndex = number
        } else {
          setBestMenuList.push({
            menuId: dataId,
            mainMenuVisibleIndex: number
          })
        }
      })
    }

    if (setBestMenuList.length > 0) {
      await bestMenuListChange(shopId, setBestMenuList);
    }

    await setMenu(
      shopId, menuGrpId, menuId, data, adminData,
      priceList, setPriceList, removePriceList,
      optionList, removeOptionList
    );
  }

  const closePopupEvent1 = () => {
    document.querySelector("#menuGrpSelect .selectText").setAttribute("data-id", "0");
    document.querySelector("#menuGrpSelect .selectText").innerText = "설정안함";
    document.querySelector("#categorySelect .selectText").setAttribute("data-id", "0");
    document.querySelector("#categorySelect .selectText").innerText = "설정안함";
    setNewBestMenuList(bestMenuList);
    setReset(reset + 1);

    setValue("menuName", "")
    setChecked("bestMenu", false);
    setChecked("adultMenu", false);
    setValue("menuPriceName1", "");
    setValue("menuPrice1", "");
    setValue("menuSalePrice1", "");
    document.querySelectorAll(".addMenuPrice1").forEach((element) => {
      element.remove();
    })
    setValue("menuCount", 10000);

    let menuStatesRadio = document.querySelectorAll(".menuStatesRadio");
    menuStatesRadio.forEach((element) => {
      element.checked = false;
    });
    let menuStatesBtn = document.querySelectorAll(".menuStatesBtn1");
    menuStatesBtn.forEach((element) => {
      element.classList.remove("active");
    });

    setChecked(`menuStates1`, true);
    document.querySelector(`.menuStatesBtn11`).classList.add("active");

    document.querySelector("#menuImgPreview1 .menuImg").setAttribute("src", "");
    document.querySelector("#menuImgPreview1 .menuImg").setAttribute("data-id", "0");
    document.querySelector("#menuImgPreview1 .imgBtn").classList.remove("hide");
    document.querySelector("#menuImgPreview1 .imageSearchBtn").classList.remove("hide");
    document.querySelector("#menuImgPreview1 .menuImgPreview").classList.add("hide");
    document.getElementById(`bestMenuBtn1`).classList.add("d-none");

    if(serviceType === 6) {
      document.querySelector(".detailImgBox1").innerHTML = "";
      document.querySelector(".shopDetailImgBox1").innerHTML = "";
      document.querySelector("#menuInfoSelect1 .selectText").setAttribute("data-id", "0");
      document.querySelector("#menuInfoSelect1 .selectText").innerText = "설정안함";
      document.querySelector(".menuInfoList1").innerHTML = "";
    }
    setValue("menuDesc", "");
    setValue("menuInfo", "");
    document.querySelector(".menuOptionList1").innerHTML = "";

    setFileList([]);
    closePopup("newMenuPopup");
  }

  const closePopupEvent2 = () => {
    setFileList([]);
    setModifyFileList([]);
    setNewBestMenuList(bestMenuList);
    setReset(reset + 1);
    closePopup("modifyMenuPopup");
  }

  const closePopupEvent3 = () => {
    setReset(false);
    setMenuList([]);
    document.querySelector("#menuDrgSelect .selectText").setAttribute("data-id", "0");
    document.querySelector("#menuDrgSelect .selectText").innerText = "설정안함";
    closePopup("menuPopup3");
  }

  const menuInfo1 = (id) => {
    document.querySelector(".menuInfoList1").innerHTML = "";

    if(id !== '0') {
      let menuInfo = MenuInfo.MenuInfoList(id)

      for(let i = 0; menuInfo.length > i; i++) {
        const div = document.createElement('div')
        div.innerHTML = `<p class='menuInfoTitle'>${ menuInfo[i] }</p>` +
                        `<input type='text' class='menuInfoInput' maxlength='100' />`;
        div.setAttribute('class', 'menuInfoInputBox')
        document.querySelector(".menuInfoList1").appendChild(div);
      }
    }
    document.getElementById("menuInfoSelect1").classList.remove("active");
  }
  const menuInfo2 = (id) => {
    document.querySelector(".menuInfoList2").innerHTML = "";

    if(id !== '0') {
      let menuInfo = MenuInfo.MenuInfoList(id)

      for(let i = 0; menuInfo.length > i; i++) {
        const div = document.createElement('div')
        div.innerHTML = `<p class='menuInfoTitle'>${ menuInfo[i] }</p>` +
                        `<input type='text' class='menuInfoInput' maxlength='100' />`;
        div.setAttribute('class', 'menuInfoInputBox')
        document.querySelector(".menuInfoList2").appendChild(div);
      }
    } else {
      document.querySelector(".menuInfoList2").innerHTML = "";
    }
    document.getElementById("menuInfoSelect2").classList.remove("active");
  }

  const menuListChangeEvent = () => {
    const menuGrpId = Number(document.querySelector("#menuDrgSelect .selectText").getAttribute("data-id"));
    let dataList = [];
    const menuBox = document.querySelectorAll("#menuPopup3 .popupDragTitle");

    if(menuBox.length > 0) {
      menuBox.forEach((element) => {
        const dataId = element.getAttribute("data-id");
        const dataStatus = element.getAttribute("data-status");
        dataList.push({
          menuId: Number(dataId),
          menuStatus: Number(dataStatus)
        });
      });

      document.getElementById("menuPopup3Btn").setAttribute("disabled", true);
      menuListChange(shopId, menuGrpId, dataList);
    }
  }

  if(category.length > 0) {
    let categoryBox = document.querySelector("#categorySelect .selectText");
    categoryBox.innerText = category[0].name;
    categoryBox.setAttribute("data-id", category[0].id);
  }

  const handleBestMenuChange = (e, type) => {
    const isChecked = e.target.checked;
    const menuImgPreview = document.querySelector(`#menuImgPreview${type} .menuImgPreview`);
    const bestMenuBtn = document.getElementById(`bestMenuBtn${type}`);
    const menuId = getValue("menuId2");
    bestMenuBtn.classList.add("d-none");

    if (!bestMenuList.filter((value) => value.id === Number(menuId))) {
      if (isChecked && bestMenuList.length >= 5) {
        alert("대표 메뉴는 최대 5개까지만 설정할 수 있습니다.");
        e.target.checked = false;
        return false
      }
    }

    if (isChecked && menuImgPreview.classList.contains("hide")) {
      alert("이미지가 등록된 메뉴만 설정할 수 있습니다.");
      e.target.checked = false;
      return false
    }

    if (e.target.checked) {
      bestMenuBtn.classList.remove("d-none");
    }
  };

  return (
    <>
      <div>
        <div id="newMenuPopup" className="menuPopup menuPopup1 popupV2 hide">
          <div className='popupContainer width808'>
            <div className='popupTitle'>
              <h2>메뉴 추가</h2>
              <button className='closeBtn' onClick={() => closePopupEvent1()}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className="popupContent">
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>그룹 선택</div>
                <div className='flexContent'>
                  <div id='menuGrpSelect' className='popupSelect select selectBox' style={{zIndex: 200}}>
                    <div className='menuGrpSelect selectText selectTextBox' data-href="menuGrpSelect" data-id='0'>설정안함</div>
                    <ul id="menuGrpSelectUl" className='selectOptionListBox selectOptionList' data-href='menuGrpSelect'>
                      <li className="selectoption" data-name="설정안함" onClick={() => menuGrpListEvent("0", "설정안함", "menuGrpSelect")}>설정안함</li>
                      {menuGrpList1}
                    </ul>
                  </div>
                </div>
              </div>

              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox shopping'>
                <div className='flexTitle'>카테고리 선택</div>
                <div className='flexContent'>
                  <div id='categorySelect' className='popupSelect select selectBox' style={{zIndex: 199}}>
                    <div className='categorySelect selectText selectTextBox' data-href='categorySelect' data-id='0'>설정안함</div>
                    <ul id="categorySelectUl" className='selectOptionListBox selectOptionList' data-href='categorySelect'>
                      <li className="selectoption" onClick={() => menuGrpListEvent("0", "설정안함", "categorySelect")}>설정안함</li>
                      {categoryList1}
                    </ul>
                  </div>
                  {/*<div id='subCategory1' className='popupSelect select marginTop5 hide' style={{zIndex: 198}}>
                  <div className='subCategory1 selectText' data-href='subCategory1' data-id='0'>설정안함</div>
                  <ul className='selectOptionList' data-href='subCategory1'>

                  </ul>
                </div>
                <div id='subCategory2' className='popupSelect select marginTop5 hide' style={{zIndex: 197}}>
                  <div className='subCategory2 selectText' data-href='subCategory2' data-id='0'>설정안함</div>
                  <ul className='selectOptionList' data-href='subCategory2'>

                  </ul>
                </div>*/}
                </div>
              </div>

              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>메뉴명</div>
                <div className='flexContent'>
                  <input type='text' id='menuName' className='resetInput' name='menuName' placeholder='메뉴명 입력' />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'></div>
                <div className='flexCheckBox'>
                  <input type='checkbox' id='bestMenu' name='bestMenu' className='food hide' onChange={(e) => handleBestMenuChange(e, 1)} />
                  <label htmlFor="bestMenu" className="label1">대표메뉴로 설정</label>
                  <input type='checkbox' id='adultMenu' name='adultMenu' />
                  <label htmlFor="adultMenu">19세이하 구매제한 설정</label>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'></div>
                <div className='flexContent'>
                  <button id="bestMenuBtn1" className="bg-blue fc-white d-none" type="button" onClick={() => handleBestMenuListEvent(1)}>대표메뉴 순서설정</button>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                <div className='flexTitle'>가격</div>
                <div className='flexContent'>
                  <div className='menuPriceBoxTitle'>
                    <h4 className='width180'>가격명</h4>
                    <h4 className='width134'>{serviceType === 6 ? "정상가격" : "가격 금액"}</h4>
                    <h4 className={`width134 ${serviceType === 6 ? "" : "hide"}`}>판매가격</h4>
                  </div>
                  <div id="menuPriceList1" className='menuPriceList menuPriceList1'>
                    <div className='menuPriceBox'>
                      <input type='text' id="menuPriceName1" className='menuPriceName' name='menuPriceName' placeholder='가격명' />
                      <input type='number' id='menuPrice1' className='menuPrice' name='menuPrice' placeholder='가격 입력(숫자만)' />
                      <input type='number' id='menuSalePrice1' className={`menuSalePrice width134 ${serviceType === 6 ? "" : "hide"}`} name='menuSalePrice' placeholder='가격 입력(숫자만)' />
                    </div>
                  </div>
                  {serviceType !== 6 &&
                    <>
                      <button className='priceAddBtn' onClick={() => menuPriceEvent(1)}>추가</button><br />
                      <span className='red'>※ 상품가격을 2개 이상 설정 시, 이름을 입력하지 않은 값은 노출이 안됩니다.</span>
                    </>
                  }
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>판매수량(재고)</div>
                <div className='flexContent'>
                  <input type='number' id='menuCount' name='menuCount' placeholder='수량 입력(숫자만)' defaultValue={ 10000 } />개
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox popupLine'>
                <div className='flexTitle'>상태</div>
                <div className='flexContent'>
                  <input type='radio' value={1} hidden defaultChecked name='menuStates1' id='menuStates1' className='menuStatesRadio' />
                  <label htmlFor='menuStates1' className='menuStatesBtn menuStatesBtn1 menuStatesBtn11 active' onClick={() => menuStatesBtnEvent(1, 1)}>
                    <img className='img1' src={ radioBtn1 } alt='' />
                    <img className='img2' src={ radioBtn2 } alt='' />
                    판매
                  </label>
                  <input type='radio' value={2} hidden name='menuStates1' id='menuStates2' className='menuStatesRadio' />
                  <label htmlFor='menuStates2' className='menuStatesBtn menuStatesBtn1 menuStatesBtn12' onClick={() => menuStatesBtnEvent(2, 1)}>
                    <img className='img1' src={ radioBtn1 } alt='' />
                    <img className='img2' src={ radioBtn2 } alt='' />
                    판매중지
                  </label>
                  <input type='radio' value={3} hidden name='menuStates1' id='menuStates3' className='menuStatesRadio' />
                  <label htmlFor='menuStates3' className='menuStatesBtn menuStatesBtn1 menuStatesBtn13' onClick={() => menuStatesBtnEvent(3, 1)}>
                    <img className='img1' src={ radioBtn1 } alt='' />
                    <img className='img2' src={ radioBtn2 } alt='' />
                    품절
                  </label><br />
                  <span className='red'>※ ‘판매중지’ 선택시, 고객에게 메뉴가 노출되지 않습니다.</span>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                <div className='flexTitle'>메뉴 이미지<br /><span>(선택)</span></div>
                <div id="menuImgPreview1" className='flexContent'>
                  <input type='file' id='menuImgFile' className='menuImgFile' accept='image/jpeg, image/png' hidden onChange={(e) => fileUpload(e, "menuImgPreview1")} />
                  <div className="d-flex a-center j-left">
                    <label htmlFor='menuImgFile' className='imgBtn'>
                      <img src={ imgBtn } alt='' />
                      이미지 업로드
                    </label>
                    <button
                      type="text"
                      className="imageSearchBtn bg-blue fc-white ml-5"
                      onClick={() => openPopup("menuImageSearchPopup1")}
                    >
                      이미지 검색
                    </button>
                  </div>
                  <div className='menuImgPreview hide'>
                    <img src='' alt='' className='menuImg' />
                    <button className='menuImgRemoveBtn' onClick={() => imageRemove("menuImgPreview1")}>
                      <img src={ imgRemoveBtn } alt='' />
                    </button>
                  </div>
                  <span>※ 메뉴 이미지 권장 사이즈 720*720, 3MB이하의 jpg, png 파일만 가능합니다.</span>
                </div>
              </div>
              {serviceType === 6 &&
                <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                  <div className='flexTitle'>상세 이미지<br /><span>(선택)</span></div>
                  <div className='flexContent'>
                    <input type='file' id='detailFile1' accept='image/jpeg, image/png' hidden onChange={(e) => handleChange1(e)} />
                    <label htmlFor='detailFile1' className='img1Btn'>
                      <img src={ imgBtn } alt='' />
                      이미지 업로드
                    </label>
                    <div className='detailImgBox detailImgBox1'>

                    </div>
                    <div className='shopDetailImgBox shopDetailImgBox1'>

                    </div>
                  </div>
                </div>
              }
              <div className={`popupFlexBox popupFlexBox1 popupFlexTopBox ${serviceType === 6 ? "hide" : ""}`}>
                <div className='flexTitle'>메뉴 구성 설명<br /><span>(선택)</span></div>
                <div className='flexContent'>
                  <textarea id='menuDesc' placeholder='메뉴 구성 설명' />
                </div>
              </div>
              <div className={`popupFlexBox popupFlexBox1 popupFlexTopBox popupLine ${serviceType === 6 ? "hide" : ""}`}>
                <div className='flexTitle'>메뉴 상세 설명<br /><span>(선택)</span></div>
                <div className='flexContent'>
                  <textarea id='menuInfo' placeholder='메뉴 상세 설명' />
                </div>
              </div>
              <div className='popupFlexBox popupFlexTopBox'>
                <div className='flexTitle'>옵션 설정<span>(선택)</span></div>
                <div className='flexContent modiOptionListBox'>
                  <div id='menuOptionSelect1' className='popupSelect select selectBox' style={{zIndex: 196}}>
                    <div className='menuOptionSelect selectText selectTextBox' data-href='menuOptionSelect1' data-id='0'>설정안함</div>
                    <ul id="menuOptionSelect1Ul" className='selectOptionListBox selectOptionList' data-href='menuOptionSelect1'>
                      <li className="selectoption" data-name="설정안함" onClick={() => menuGrpListEvent("0", "설정안함", "menuOptionSelect1")}>설정안함</li>
                      {optionGrpList}
                    </ul>
                  </div>
                  {/*<button className='optionBtn optionBtn1' onClick={() => openPopup("menuPopup4")}>
                  <img src={ optionBtn1 } alt="추가" />
                </button>*/}
                  <button className='optionBtn optionBtn1' onClick={() => optionGrpAddEvent(1)}>
                    <img src={ optionBtn1 } alt="추가" />
                  </button>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='menuOptionList1 menuOptionList height200'>

                </div>
              </div>
              {serviceType === 6 &&
                <>
                  <div className='popupFlexBox popupFlexTopBox shopping'>
                    <div className='flexTitle'>상품정보고시<span>(선택)</span></div>
                    <div className='flexContent menuInfoListBox'>
                      <div id='menuInfoSelect1' className='popupSelect select selectBox' style={{zIndex: 195}}>
                        <div className='menuInfoSelect1 selectText selectTextBox' data-href='menuInfoSelect1' data-id='0'>설정안함</div>
                        <ul id="menuInfoSelect1Ul" className='selectOptionListBox selectOptionList' data-href='menuInfoSelect1'>
                          { menuInfoList1 }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className='popupFlexBox popupFlexBox1 shopping'>
                    <div className='menuInfoList1 menuInfoList height200'>
                      <MenuDrag items={ menuList } />
                    </div>
                  </div>
                </>
              }



              <div className='spanBox'>
                <span>※ 사장님이 직접 수정하신 사항에 대한 책임은 사장님 본인에게 있습니다.</span><br />
                <span>※ 잘못 추가한 메뉴로 인한 손해에 대해서는 당사는 어떠한 책임도 부담하지 않습니다.</span>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopupEvent1()}>취소</button>
              <button type='button' id="menu1Btn" className='menu1Btn blueBtn' onClick={() => addMenuEvent()}>확인</button>
            </div>
          </div>
        </div>

        <div id="modifyMenuPopup" className="menuPopup menuPopup2 popupV2 hide">
          <div className='popupContainer width808'>
            <div className='popupTitle'>
              <h2>메뉴 수정</h2>
              <button className='closeBtn' onClick={() => closePopupEvent2()}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className="popupContent">
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>그룹 선택</div>
                <div className='flexContent'>
                  <div id='menuGrpSelect2' className='popupSelect select selectBox' style={{zIndex: 200}}>
                    <div className='menuGrpSelect selectText selectTextBox' data-href="menuGrpSelect2" data-id='0'>설정안함</div>
                    <ul id='menuGrpSelect2Ul' className='selectOptionListBox selectOptionList' data-href="menuGrpSelect2">
                      <li className="selectoption" data-name="설정안함" onClick={() => menuGrpListEvent("0", "설정안함", "menuGrpSelect2")}>설정안함</li>
                      {menuGrpList2}
                    </ul>
                  </div>
                </div>
              </div>

              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox shopping'>
                <div className='flexTitle'>카테고리 선택</div>
                <div className='flexContent'>
                  <div id='categorySelect2' className='popupSelect select selectBox' style={{zIndex: 199}}>
                    <div className='categorySelect selectText selectTextBox' data-href='categorySelect2' data-id='0'>설정안함</div>
                    <ul id='categorySelect2Ul' className='selectOptionListBox selectOptionList' data-href='categorySelect2'>
                      <li className="selectoption" onClick={() => menuGrpListEvent("0", "설정안함", "categorySelect2")}>설정안함</li>
                      {categoryList2}
                    </ul>
                  </div>
                </div>
              </div>

              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>메뉴명</div>
                <div className='flexContent'>
                  <input type='text' id='menuName2' className='resetInput' name='menuName' placeholder='메뉴명 입력' />
                  <input type="hidden" id="menuId2" />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'></div>
                <div className='flexCheckBox'>
                  <input type='checkbox' id='bestMenu2' name='bestMenu2' className='food hide' onChange={(e) => handleBestMenuChange(e, 2)} />
                  <label htmlFor="bestMenu2" className="label1">대표메뉴로 설정</label>
                  <input type='checkbox' id='adultMenu2' name='adultMenu2' />
                  <label htmlFor="adultMenu2">19세이하 구매제한 설정</label>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'></div>
                <div className='flexContent'>
                  <button id="bestMenuBtn2" className="bg-blue fc-white d-none" type="button" onClick={() => handleBestMenuListEvent(2)}>대표메뉴 순서설정</button>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                <div className='flexTitle'>가격</div>
                <div className='flexContent'>
                  <div className='menuPriceBoxTitle'>
                    <h4 className='width180'>가격명</h4>
                    <h4 className='width134'>{serviceType === 6 ? "정상가격" : "가격 금액"}</h4>
                    <h4 className={`width134 ${serviceType === 6 ? "" : "hide"}`}>판매가격</h4>
                  </div>
                  <div id="menuPriceList2" className='menuPriceList menuPriceList2'>
                    <div className='menuPriceBox menuPriceBox2' data-id={0} data-modi={1}>
                      <input type='text' id="menuPriceName2" className='menuPriceName' name='menuPriceName' placeholder='가격명' />
                      <input type='number' id='menuPrice2' className='menuPrice' name='menuPrice' placeholder='가격 입력(숫자만)' />
                      <input type='number' id='menuSalePrice2' className={`menuSalePrice width134 ${serviceType === 6 ? "" : "hide"}`} name='menuSalePrice' placeholder='가격 입력(숫자만)' />
                    </div>
                  </div>
                  {serviceType !== 6 &&
                    <>
                      <button className='priceAddBtn' onClick={() => menuPriceEvent(2)}>추가</button><br/>
                      <span className='red'>※ 상품가격을 2개 이상 설정 시, 이름을 입력하지 않은 값은 노출이 안됩니다.</span>
                    </>
                  }
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>판매수량(재고)</div>
                <div className='flexContent'>
                  <input type='number' id='modiMenuCount' name='menuCount' placeholder='수량 입력(숫자만)' />개
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox popupLine'>
                <div className='flexTitle'>상태</div>
                <div className='flexContent'>
                  <input type='radio' value={1} hidden name='menuStates2' id='menuStates21' className='menuStatesRadio menuStatesRadio2' />
                  <label htmlFor='menuStates21' className='menuStatesBtn menuStatesBtn2 menuStatesBtn21' onClick={() => menuStatesBtnEvent(1, 2)}>
                    <img className='img1' src={ radioBtn1 } alt='' />
                    <img className='img2' src={ radioBtn2 } alt='' />
                    판매
                  </label>
                  <input type='radio' value={2} hidden name='menuStates2' id='menuStates22' className='menuStatesRadio menuStatesRadio2' />
                  <label htmlFor='menuStates22' className='menuStatesBtn menuStatesBtn2 menuStatesBtn22' onClick={() => menuStatesBtnEvent(2, 2)}>
                    <img className='img1' src={ radioBtn1 } alt='' />
                    <img className='img2' src={ radioBtn2 } alt='' />
                    판매중지
                  </label>
                  <input type='radio' value={3} hidden name='menuStates2' id='menuStates23' className='menuStatesRadio menuStatesRadio2' />
                  <label htmlFor='menuStates23' className='menuStatesBtn menuStatesBtn2 menuStatesBtn23' onClick={() => menuStatesBtnEvent(3, 2)}>
                    <img className='img1' src={ radioBtn1 } alt='' />
                    <img className='img2' src={ radioBtn2 } alt='' />
                    품절
                  </label><br />
                  <span className='red'>※ ‘판매중지’ 선택시, 고객에게 메뉴가 노출되지 않습니다.</span>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
                <div className='flexTitle'>메뉴 이미지<br /><span>(선택)</span></div>
                <div id="menuImgPreview2" className='flexContent'>
                  <input type='file' id='menuImgFile2' className='menuImgFile' accept='image/jpeg, image/png' hidden onChange={(e) => fileUpload(e, "menuImgPreview2")} />
                  <div className="d-flex a-center j-left">
                    <label htmlFor='menuImgFile2' className='imgBtn'>
                      <img src={ imgBtn } alt='' />
                      이미지 업로드
                    </label>
                    <button
                      type="text"
                      className="imageSearchBtn bg-blue fc-white ml-5"
                      onClick={() => openPopup("menuImageSearchPopup2")}
                    >
                      이미지 검색
                    </button>
                  </div>
                  <div className='menuImgPreview menuImgPreview2 hide'>
                    <img src='' alt='' className='menuImg' />
                    <button className='menuImgRemoveBtn' onClick={() => imageRemove("menuImgPreview2")}>
                      <img src={ imgRemoveBtn } alt='' />
                    </button>
                  </div>
                  <span>※ 메뉴 이미지 권장 사이즈 720*720, 3MB이하의 jpg, png 파일만 가능합니다.</span>
                </div>
              </div>
              {serviceType === 6 &&
                <div className='popupFlexBox popupFlexBox1 popupFlexTopBox shopType6 shopping'>
                  <div className='flexTitle'>상세 이미지<br /><span>(선택)</span></div>
                  <div className='flexContent'>
                    <input type='file' id='detailFile2' accept='image/jpeg, image/png' hidden onChange={(e) => handleChange2(e)} />
                    <label htmlFor='detailFile2' className='img1Btn'>
                      <img src={ imgBtn } alt='' />
                      이미지 업로드
                    </label>
                    <div className='detailImgBox detailImgBox2'>

                    </div>
                    <div className='shopDetailImgBox shopDetailImgBox2'>

                    </div>
                  </div>
                </div>
              }
              <div className={`popupFlexBox popupFlexBox1 popupFlexTopBox ${serviceType === 6 ? "hide" : ""}`}>
                <div className='flexTitle'>메뉴 구성 설명<br /><span>(선택)</span></div>
                <div className='flexContent'>
                  <textarea id='menuDesc2' placeholder='메뉴 구성 설명' />
                </div>
              </div>
              <div className={`popupFlexBox popupFlexBox1 popupFlexTopBox popupLine ${serviceType === 6 ? "hide" : ""}`}>
                <div className='flexTitle'>메뉴 상세 설명<br /><span>(선택)</span></div>
                <div className='flexContent'>
                  <textarea id='menuInfo2' placeholder='메뉴 상세 설명' />
                </div>
              </div>
              <div className='popupFlexBox popupFlexTopBox'>
                <div className='flexTitle'>옵션 설정<span>(선택)</span></div>
                <div className='flexContent modiOptionListBox'>
                  <div id='menuOptionSelect2' className='popupSelect select selectBox' style={{zIndex: 196}}>
                    <div className='menuOptionSelect selectText selectTextBox' data-href='menuOptionSelect2' data-id='0'>설정안함</div>
                    <ul id='menuOptionSelect2Ul' className='selectOptionListBox selectOptionList' data-href='menuOptionSelect2'>
                      <li className="selectoption" data-name="설정안함" onClick={() => menuGrpListEvent("0", "설정안함", "menuOptionSelect2")}>설정안함</li>
                      {optionGrpList2}
                    </ul>
                  </div>
                  <button className='optionBtn optionBtn1' onClick={() => optionGrpAddEvent(2)}>
                    <img src={ optionBtn1 } alt="추가" />
                  </button>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div id="menuOptionList2" className='menuOptionList2 menuOptionList height200'>

                </div>
              </div>
              {serviceType === 6 &&
                <>
                  <div className='popupFlexBox popupFlexTopBox shopping'>
                    <div className='flexTitle'>상품정보고시<span>(선택)</span></div>
                    <div className='flexContent menuInfoListBox'>
                      <div id='menuInfoSelect2' className='popupSelect select selectBox' style={{zIndex: 195}}>
                        <div className='menuInfoSelect2 selectText selectTextBox' data-href='menuInfoSelect2' data-id='0'>불러오기</div>
                        <ul id="menuInfoSelect2Ul" className='selectOptionListBox selectOptionList' data-href='menuInfoSelect2'>
                          <li className="selectoption" onClick={() => menuGrpListEvent("0", "설정안함", "menuInfoSelect2")}>설정안함</li>
                          { menuInfoList2 }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className='popupFlexBox popupFlexBox1 shopping'>
                    <div className='menuInfoList2 menuInfoList height200'>

                    </div>
                  </div>
                </>
              }
              <div className='spanBox'>
                <span>※ 사장님이 직접 수정하신 사항에 대한 책임은 사장님 본인에게 있습니다.</span><br />
                <span>※ 잘못 추가한 메뉴로 인한 손해에 대해서는 당사는 어떠한 책임도 부담하지 않습니다.</span>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopupEvent2()}>취소</button>
              <button type='button' id="menu2Btn" className='blueBtn' onClick={() => setMenuEvent()}>확인</button>
            </div>
          </div>
        </div>

        <div id="menuPopup3" className='menuPopup3 popupV2 hide'>
          <div className='popupContainer'>
            <div className='popupTitle'>
              <h2>메뉴 순서 변경</h2>
              <button className='menuPopup3CloseBtn closeBtn' onClick={() => closePopupEvent3()}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>그룹 선택</div>
                <div className='flexContent'>
                  <div id='menuDrgSelect' className='popupSelect select selectBox'>
                    <div className='menuDrgSelect selectText selectTextBox' data-href='menuDrgSelect' data-id='0'>설정안함</div>
                    <ul id="menuDrgSelectUl" className='selectOptionListBox selectOptionList' data-href='menuDrgSelect'>
                      {menuDrgSelect}
                    </ul>
                  </div>
                </div>
              </div>
              <div className='popupDragBox'>
                <MenuDrag items={menuList} reset={reset} />
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='menuPopup3CloseBtn closeBtn' onClick={() => closePopupEvent3()}>취소</button>
              <button type='button' id="menuPopup3Btn" className='menuPopup3Btn blueBtn' onClick={() => menuListChangeEvent()}>확인</button>
            </div>
          </div>
        </div>

        <div id="menuPopup4" className='menuPopup4 popupV2 hide'>
          <div className='popupContainer'>
            <div className='popupTitle'>
              <h2>옵션 선택</h2>
              <button className='closeBtn2' onClick={() => closePopup("menuPopup4")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexContent'>
                  <ul className="optionListBox">
                    {optionGrpSelectList}
                  </ul>
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn2' onClick={() => closePopup("menuPopup4")}>취소</button>
              <button type='button' className='menuPopup4Btn blueBtn'>확인</button>
            </div>
          </div>
        </div>

        <div id="menuPopup5" className='menuGrpPopup2 popupV2 hide'>
          <div className='popupContainer'>
            <div className='popupTitle'>
              <h2>대표메뉴 순서 변경</h2>
              <button className='closeBtn menuGrpPopup2closeBtn' onClick={() => {
                closePopup("menuPopup5");
                setReset(reset + 1);
              }}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupDragBox'>
                <BestMenuDrag items={newBestMenuList} reset={reset} />
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn menuGrpPopup2closeBtn' onClick={() => {
                closePopup("menuPopup5");
                setReset(reset + 1);
              }}>순서 초기화</button>
              <button type='button' id="menuGrp2Btn" className='menuGrp2Btn blueBtn' onClick={() => closePopup("menuPopup5")}>확인</button>
            </div>
          </div>
        </div>
      </div>
      <MenuImageSearchPopup2 setFileList={setFileList} setModifyFileList={setModifyFileList} />
    </>
  )
}